import { render, staticRenderFns } from "./CreateClientCompany.vue?vue&type=template&id=20fd0314&"
import script from "./CreateClientCompany.vue?vue&type=script&lang=js&"
export * from "./CreateClientCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports